<template>
  <div id="order_history_detail">
    <dd-header />
    <!--  メインコンテンツ  -->
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <h1>ご注文履歴詳細</h1>
          <dd-history-detail
            :orderNo="orderNo"
          />
        </div>
      </div>
      <dd-footer />
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import LoadingModal from '../../components/common/LoadingModal'
import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import DcHistoryDetail from '../components/mypage/DcHistoryDetail'

export default {
  name: 'DcOrderHistoryDetail',
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap,
    'dd-history-detail': DcHistoryDetail,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'orderHistoryDetail',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'mypage', key: 'dcMyPage', title: 'マイページ', route: 'DcMyPage'},
        {id: 'orderHistoryList', key: 'orderHistoryList', title: '注文履歴リスト', route: 'DcOrderHistoryList'},
        {id: 'orderHistoryDetail', key: 'orderHistoryDetail', title: '注文履歴詳細'}
      ],
      orderNo: ''
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
  },
  mounted: function () {
  },
  created: function () {
    if (this.$route.params.orderNo !== undefined) {
      this.orderNo = this.$route.params.orderNo
      localStorage.setItem('OrderNo', JSON.stringify(this.$route.params.orderNo))
    } else {
      this.orderNo = JSON.parse(localStorage.getItem('OrderNo'))
    }
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>
<style src="../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcOrderHistoryDetail.vue